import React from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import WithLabel, { LABEL_STYLES } from '../../../components/with-label/WithLabel';
import { Input } from '../../../components/common-inputs';

import scss from './ConvertInput.module.scss';

function ConvertInput({ name, label, isRequired, onSubmit, disabled }) {
  const { t } = useTranslation('studio');

  return (
    <WithLabel variant={LABEL_STYLES.COLUMN} label={label} isRequired={isRequired} isBold isTwoDots>
      <div className={scss.convertInput}>
        <Field name={`${name}_from`}>
          {({ input, meta }) => (
            <Input
              size='sm'
              name={input.name}
              value={input.value ?? ''}
              onChange={input.onChange}
              formProps={input}
              placeholder={t('from')}
              isError={meta.touched && meta.error}
              onEnter={onSubmit}
              disabled={disabled}
            />
          )}
        </Field>

        <span className={scss.separator}>-</span>

        <Field name={`${name}_to`}>
          {({ input, meta }) => (
            <Input
              size='sm'
              name={input.name}
              value={input.value ?? ''}
              onChange={input.onChange}
              formProps={input}
              isError={meta.touched && meta.error}
              placeholder={t('to')}
              onEnter={onSubmit}
              disabled={disabled}
            />
          )}
        </Field>
      </div>
    </WithLabel>
  );
}

export default ConvertInput;
